import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';
import i18next from './i18next';

dayjs.extend(duration);

const diffAsDHMS = (myDate: string) => {
  const now = dayjs();
  const end = dayjs(myDate);

  const diffMs = end.diff(now);

  if (diffMs <= 0) {
    return '0 Seconds';
  }

  const d = dayjs.duration(diffMs);
  const days = Math.floor(d.asDays());
  const hours = d.hours();
  const minutes = d.minutes();
  const seconds = d.seconds();

  if (days > 0) {
    return i18next.t('common:days', { days });
  }
  if (hours > 0) {
    return i18next.t('common:hours', { hours });
  }
  if (minutes > 0) {
    return i18next.t('common:minutes', { minutes });
  }
  return i18next.t('common:seconds', { seconds });
};

export default diffAsDHMS;
